import {Image, ImageProps} from '@chakra-ui/react';
import React from 'react';

type Props = ImageProps & {fallbacksrc?: string};

const ImageUI = (props: Props) => {
  if (!props.src) return null;
  const alt = props.alt ?? props.src;
  return <Image {...props} alt={alt} />;
  // return <ChakraNextImg width="150" height="150" {...props} alt={`${alt}`} />;
};

export default ImageUI;
